module.exports = __webpack_public_path__ + "static/img/shareholder.45296d8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sustainable/company/shareholder.png
// module id = QO15
// module chunks = 2